<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <h4 class="card-title" style="font-weight:bold;">Les Logisticiens</h4>
            </template>

            <table class="table">

              <thead>
                <tr>
                  <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">#</th>
                  <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Rôle</th>
                  <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Noms et Prénoms</th>
                  <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Contacts</th>
                  <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Actions</th>
                </tr>
              </thead>

              <tbody>
                  
                <tr v-for="(livreur) in livreurs" :key="livreur.id">
                  <td>{{ livreurs.indexOf(livreur) + 1 }}</td>
                  <td>{{ livreur.role }}</td>
                  <td>{{ livreur.name }}</td>
                  <td>{{ livreur.number }}</td>
                  <td>
                    <router-link :to="{path: '/Client_edit/' + livreur.id }" v-bind:tooltip="livreur.id"  class="btn btn-default">
                      <i class="fa fa-pencil" aria-hidden="true" style="color:blue; font-weight:bold"></i>
                    </router-link>
                    <button @click="removeLivreurs(livreur.id)" class="btn btn-default">
                      <i class="fa fa-trash" aria-hidden="true" style="color:red; font-weight:bold"></i>
                    </button>
                  </td>
                </tr>

              </tbody>
            </table>

          </card>

          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              first-number
            ></b-pagination>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import "firebase/auth";
  import { db } from '../../main';
  import Swal from "sweetalert2";
  
  export default {
    name: "Livreurs",
    data() {
      return {
        livreurs: [],
        rows: 100,
          perPage: 3,
          currentPage: 3,
        role:"",
      };
    },
    
    methods: {
      removeLivreurs(key){
        Swal.fire({
        title: 'Êtes vous sûr?',
        text: "Voulez vous vraiment supprimer ce compte!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#34B76E',
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Supprimer'
      }).then((result) => {
        if (result.isConfirmed) {
          db.ref("users").child(key).remove();
          Swal.fire(
            'Supprimer!',
            'Le compte a été supprimé avec succès.',
            'success'
          )
        }
      })
      }
    },
    
    created(){
        db.ref("users")
        .orderByChild("role")
        .equalTo("4")
        .once("value")
        .then((dataSnapshot) => {
            const itemsArray = [];
            dataSnapshot.forEach((childSnapshot) => {
                const childData = childSnapshot.val();
                itemsArray.push({
                    id: childData.id,
                    role: childData.role,
                    statusLivreur: childData.statusLivreur,
                    name: childData.name,
                    number: childData.number,
                    email: childData.email,
                });
            });
            this.livreurs = itemsArray;
        });
    },

  };

</script>


<style>
    .btn-primary {
        margin-right: 12px;
    }
</style>

